import './customNotification.css';
import cx from "classnames";

const CustomNoti = (props: any) => {


    return <div className={cx("nofiFication", props.type)}>
        <div className='notiHeader'><b>{props.title}</b></div>
        <div className='notiBody' dangerouslySetInnerHTML={{ __html: props.message }}></div>
    </div>
}
export default CustomNoti;